<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-input
			  v-model="key"
			  placeholder="请输入搜索关键词"
			  class="input-with-select"
			>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%" height="640">
	    <el-table-column fixed prop="order_no" label="订单号" width="120" />
	    <el-table-column fixed prop="rq_sj" label="预订时间" width="200" />
		<el-table-column  prop="start_date" label="出发时间" width="200" />
		<el-table-column  prop="end_date" label="预计结束时间" width="200" />
	    <el-table-column prop="from_add" label="出发地" width="320" />
		<el-table-column prop="to_add" label="目的地" width="320" />
		<el-table-column prop="hbh" label="航班号" width="120" />
		<el-table-column prop="ck_xm" label="乘客" width="220" />
		<el-table-column  prop="xm" label="司机姓名" width="120" />
		<el-table-column  prop="zt" label="订单状态" width="*" />
	</el-table>
	<div class="pagination-custom">
		<el-pagination :page-size="pageSize" @current-change="changePageNo" background layout="pager" :total="total" />
	</div>
</template>

<script setup>
	import { ref,provide,inject,onMounted } from 'vue';
	import axios from 'axios';
	import { useMemberStore } from '../../stores';
	import { ElMessage } from 'element-plus'
	const userStore = useMemberStore();
	
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const key = ref('');
	const tableData = ref([]);
	onMounted(async() => {
		const response = await axios.post('/orderSjdd/queryList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = parseInt(response.data.total);
		}
	});
	const fetchOrders = async () => {
		const response = await axios.post('/orderSjdd/queryList', {
		  key:'order_no',
		  value:key.value,
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = parseInt(response.data.total);
		}
	};
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
</style>
